import { createRoot } from 'react-dom/client'; // For React 18+

import "./view.scss";

const initPostList = () => {
    const mountPoints = document.querySelectorAll('.wp-block-prismal-post-list:not(.wp-block-prismal-hydrated)');

    mountPoints.forEach(mountPoint => {
        const root = createRoot(mountPoint);
        root.render(window.prismal.parserMap(mountPoint.innerHTML));
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPostList);
} else {
    initPostList();
}